import { ETypesFilter } from './hooks/useTransactionsData';

export const STYLES = {
  WRAPPER: 'w-full h-full flex flex-col relative pl-[72px] pt-[78px] pb-[10px] relative',
  PAGE_TITLE: 'font-metricRSemibold text-bw08 text-[20px] mb-[24px]',
  PAGE_SUB_TITLE: 'font-metricR text-[16px] text-bw07 mb-[36px]',
  DETAILS_DRAWER:
    'flex flex-col h-full w-[450px] bg-bw01 absolute right-0 top-0 translate-x-[100%] slide-in-right shadow-rightDrawerShadow z-[999]',
  FILTER_TRIGGER: 'w-[40px] h-[40px] flex items-center justify-center',
  FILTER_PERIOD_TRIGGER: 'w-fit py-[4px] border border-bw03 bg-bw00 flex items-center rounded-[4px] hover:shadow-light',
  FILTER_WRAPPER: 'flex items-center gap-[12px] mb-[8px]',
  PERIOD_LIST:
    'flex flex-col gap-[8px] items-center border border-bw03 rounded-[8px] px-[10px] py-[20px] basis-[150px] min-w-[150px] h-full shadow-light',
  PERIOD_LIST_ITEM: 'w-full px-[12px] py-[8px] text-left rounded-[3px]',
  PERIOD_LIST_ITEM_TITLE: 'font-metricR text-[14px] text-bw08',
  PERIOD_TRIGGER: {
    WRAPPER: 'flex items-center px-[16px]',
    TITLE: 'mr-[20px] font-metricR text-[14px]',
  },
  FLOAT_DATE_PICKER: {
    WRAPPER:
      'absolute fadeIn bottom-0 left-0 translate-y-[calc(100%+10px)] bg-bw00 w-fit shadow-light rounded-[8px] z-50',
    CLOSE_BTN: 'absolute right-[10px] top-[10px]',
    CONTENT_CONTAINER: 'w-full h-full flex gap-[12px] border border-bw03 rounded-[8px] px-[10px] pt-[40px] pb-[16px]',
    RIGHT_CONTAINER: 'flex flex-col w-full h-full',
    CALENDAR_WRAPPER:
      'flex flex-col w-full h-full border border-bw03 rounded-[8px] shadow-light px-[8px] py-[12px] mb-[14px]',
    SELECTOR_INPUT_WRAPPER: 'w-full flex items-center gap-[10px] mb-[14px]',
    SEPARATOR: 'text-bw08 font-metricR',
  },
  FLOAT_SETTINGS: {
    WRAPPER:
      'absolute fadeIn bottom-0 left-0 translate-y-[calc(100%+10px)] bg-bw00 shadow-light rounded-[8px] w-[460px]  z-50',
    CONTENT_CONTAINER:
      'w-full h-full flex flex-col border border-bw03 rounded-[8px] px-[10px] pt-[40px] pb-[16px] gap-[12px]',
    TYPE_CONTAINER: 'w-full flex flex-col gap-[10px] border border-bw03 rounded-[8px] px-[16px] py-[16px]',
    HEADER: 'font-metricRMedium text-[16px] text-bw08',
    UL: 'flex items-end flex-wrap gap-[10px]',
    LI: 'py-[6px] px-[16px] rounded-[16px]  border font-metricR text-[14px] cursor-pointer hover:border-action03 hover:text-action03 hover:shadow-light',
    AMOUNT_RANGE_CONTAINER: 'w-full flex flex-col gap-[10px] border border-bw03 rounded-[8px] px-[16px] py-[16px]',
    CURRENCY_INPUT:
      'w-[140px] h-[50px] bg-bw00 box-border border border-bw04 focus:border-action03 hover:bg-bw01 outline-none px-[16px] rounded-md font-metricR text-[16px] text-bw08 text-left',
    SEPARATE_HEADER: 'font-metricR text-[16px] text-bw07',
  },
  SPLIT_CATEGORY_TAB: {
    CTA: 'w-full bg-action03 hover:bg-action04 py-[16px] rounded-[4px] text-bw00 font-metricRMedium mt-[16px]',
    CURRENCY_INPUT: 'w-[100px] outline-none font-metricR text-[18px] text-action03 bg-bw01',
  },
  CLEAR_BUTTON: 'text-[14px] h-[31px] w-[82px]',
  APPLY_BUTTON: 'text-[14px] h-[31px] w-[82px]',
};

export const DATES_PERIOD_PRESETS = [
  { title: 'All Transactions', id: 'any' },
  { title: 'Last 30 Days', id: 'last30Days' },
  { title: 'Last 60 Days', id: 'last60Days' },
  { title: 'Last 6 Months', id: 'last6Month' },
  { title: 'Current Year', id: 'currentYear' },
  { title: 'Last Year', id: 'lastYear' },
];

export const TRANSACTION_TYPES: { title: string; id: ETypesFilter }[] = [
  { title: 'All Types', id: ETypesFilter.NONE },
  { title: 'Purchases', id: ETypesFilter.PURCHASES },
  { title: 'Money Transfer', id: ETypesFilter.FUND_TRANSFER },
  { title: 'ATM Withdrawals', id: ETypesFilter.ATMS },
  { title: 'Check Deposits', id: ETypesFilter.CHECK_DEPOSITS },
  { title: 'Refund', id: ETypesFilter.REFUND },
];

export const CREDIT_CARDS_TRANSACTION_TYPES: { title: string; id: ETypesFilter }[] = TRANSACTION_TYPES.filter(
  (i) => i.id !== ETypesFilter.CHECK_DEPOSITS,
);

export const INITIAL_FEATURE_STATE = {
  isCustomTimeFrame: false,
};

export const INITIAL_FILTER = {
  startDate: null,
  endDate: null,
  recordCnt: 50,
  page: 1,
  pending: true,
  amountFrom: 0,
  amountTo: 0,
  transactionFilterType: '',
};
